import { render, staticRenderFns } from "./dataIframe.vue?vue&type=template&id=117c4b3a&scoped=true&"
import script from "./dataIframe.vue?vue&type=script&lang=js&"
export * from "./dataIframe.vue?vue&type=script&lang=js&"
import style0 from "./dataIframe.vue?vue&type=style&index=0&id=117c4b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117c4b3a",
  null
  
)

export default component.exports